import { BASE_URL } from "../config/config";
import { getUserCountry } from "./LocationService";

export const fetchRadioChannels = async () => {
    try {
        // Get User Location (Country Code)
        const userCountryCode = await getUserCountry();

        console.log("User Country Code:", userCountryCode); // Debugging output

        // Fetch Radio Channels Based on Country Code
        const response = await fetch(`${BASE_URL}/radio-list`);
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching Radio Channels:", error);
        throw error;
    }
};

export const fetchBlogs = async () => {
    try {
        const response = await fetch(`${BASE_URL}/blogs`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching Blogs:', error);
        throw error;
    }
};

export const fetchMostLikedChannels = async () => {
    try {
        const response = await fetch(`${BASE_URL}/most-liked`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching Most Liked Channels:', error);
        throw error;
    }
};

export const fetchMostFavoriteChannels = async () => {
    try {
        const response = await fetch(`${BASE_URL}/most-favorite`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching Most Favorite Channels:', error);
        throw error;
    }
};

export const fetchTopChannels = async () => {
    try {
        const response = await fetch(`${BASE_URL}/top-list`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching Top Channels:', error);
        throw error;
    }
};